import { render, staticRenderFns } from "./data-info.vue?vue&type=template&id=01b9b1b4&scoped=true"
import script from "./data-info.vue?vue&type=script&lang=ts"
export * from "./data-info.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b9b1b4",
  null
  
)

export default component.exports